import './index';

const isDesktop = window.matchMedia && window.matchMedia("(min-width: 768px)").matches;
smoothScroll.init();

$('.gallery, .spec__pdfs').each(function(){
  $(this).magnificPopup({
    delegate: 'a',
    type: 'image',
    removalDelay: 300,
    mainClass: 'mfp-fade',
    gallery:{
      enabled:true
    }
  });
});

//image lazy load
// echo.init({
//     offset: 200,
//     throttle: 250,
//     unload: false,
//     callback: function (element, op) {
//       // console.log(element, 'has been', op + 'ed')

//       $(element).addClass('lazyload--on');
//     }
//   });



// smooth scroll using TweenMax!
// http://codepen.io/bassta/pen/LovFG
if (isDesktop) {
  $(function(){

    var $window = $(window);    //Window object

    var scrollTime = 1;      //Scroll time
    var scrollDistance = 300;    //Distance. Use smaller value for shorter scroll and greater value for longer scroll

    $window.on("mousewheel DOMMouseScroll", function(event){

      event.preventDefault();

      var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
      var scrollTop = $window.scrollTop();
      var finalScroll = scrollTop - parseInt(delta*scrollDistance);

      TweenMax.to($window, scrollTime, {
        scrollTo : { y: finalScroll, autoKill:true },
          ease: Power1.easeOut,  //For more easing functions see http://api.greensock.com/js/com/greensock/easing/package-detail.html
          autoKill: true,
          overwrite: 5
        });

    });

  });
}